import { useTranslation, Trans } from "react-i18next";

function ChooseIndividual() {

  const { t } = useTranslation();

  const Checksvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"> <g clip-path="url(#clip0_12327_480)"> <path d="M2.27419 2.31674C-0.305863 4.92484 -0.291841 9.14547 2.31625 11.7255C4.92435 14.3056 9.14498 14.2915 11.725 11.6835C14.3051 9.07535 14.2911 4.85473 11.683 2.27468C9.07487 -0.305375 4.85424 -0.291353 2.27419 2.31674ZM10.2387 5.72409L6.62101 9.38384C6.31253 9.69232 5.80774 9.69232 5.49925 9.38384L5.35903 9.24362L4.93837 8.82296L3.76052 7.65913C3.45204 7.35065 3.45204 6.84586 3.76052 6.53737C4.06901 6.22889 4.5738 6.22889 4.88228 6.53737L6.06013 7.7012L9.11693 4.61635C9.42542 4.30787 9.93021 4.30787 10.2387 4.61635C10.5472 4.91082 10.5472 5.41561 10.2387 5.72409Z" fill="#637BF5"/> </g> <defs> <clipPath id="clip0_12327_480"> <rect width="14" height="14" fill="white"/> </clipPath> </defs> </svg>
  );

  return (
    <div className="relative overflow-hidden mt-[80px] xl:mt-[140px] flex flex-col">
        <p className="text-[20px] xl:text-[48px] poppins font-[500] text-[#061A77] xl:max-w-[683px] leading-[1.2] mx-auto text-center">
            {t("account.70")}
        </p>
        <div className="max-w-[1220px] mx-[20px] xl:mx-auto flex flex-col xl:flex-row gap-[20px] mt-[20px] xl:mt-[40px]">
            <div className="bg-[#F1F7FE] rounded-[4px] p-[24px] flex flex-col">
                <p className="poppins text-[20px] text-[#1A0402] xl:text-[32px] font-[500] leading-[1.2] ">
                    {t("account.71")}
                </p>
                <p className="mt-[6px] poppins text-[16px] xl:text-[20px] font-[500] xl:max-w-[333px]">{t("account.72")}</p>
                <div className="mt-[16px] text-[14px] text-[#000000B2] flex flex-col gap-[10px] xl:max-w-[333px]">
                    {t("account.73")}
                </div>
                <p className="mt-[20px] xl:mt-[40px] poppins text-[16px] xl:text-[20px] font-[500] xl:max-w-[333px]">{t("account.74")}</p>
                <div className="flex gap-[12px] items-center mt-[12px]">
                    <Checksvg/>
                    <p className="text-[14px] text-[#000000B2] flex flex-col gap-[10px] xl:max-w-[333px]">{t("account.75")}</p>
                </div>
                <div className="flex gap-[12px] items-center mt-[6px]">
                    <Checksvg/>
                    <p className="text-[14px] text-[#000000B2] flex flex-col gap-[10px] xl:max-w-[333px]">{t("account.76")}</p>
                </div>
                <div className="flex gap-[12px] items-center mt-[6px]">
                    <Checksvg/>
                    <p className="text-[14px] text-[#000000B2] flex flex-col gap-[10px] xl:max-w-[333px]">{t("account.77")}</p>
                </div>
                <div className="flex gap-[12px] items-center mt-[6px]">
                    <Checksvg/>
                    <p className="text-[14px] text-[#000000B2] flex flex-col gap-[10px] xl:max-w-[333px]">{t("account.78")}</p>
                </div>
                <div className="flex gap-[12px] items-center mt-[6px]">
                    <Checksvg/>
                    <p className="text-[14px] text-[#000000B2] flex flex-col gap-[10px] xl:max-w-[333px]">{t("account.79")}</p>
                </div>
            </div>
            <div className="bg-[#F1F7FE] rounded-[4px] p-[24px] flex flex-col">
                <p className="poppins text-[20px] text-[#1A0402] xl:text-[32px] font-[500] leading-[1.2] ">
                    {t("account.80")}
                </p>
                <p className="mt-[6px] poppins text-[16px] xl:text-[20px] font-[500] xl:max-w-[333px]">{t("account.81")}</p>
                <div className="mt-[16px] text-[14px] text-[#000000B2] flex flex-col gap-[10px] xl:max-w-[333px]">
                    {t("account.82")}
                </div>
                <p className="mt-[20px] xl:mt-[40px] poppins text-[16px] xl:text-[20px] font-[500] xl:max-w-[333px]">{t("account.74")}</p>
                <div className="flex gap-[12px] items-center mt-[12px]">
                    <Checksvg/>
                    <p className="text-[14px] text-[#000000B2] flex flex-col gap-[10px] xl:max-w-[333px]">{t("account.83")}</p>
                </div>
                <div className="flex gap-[12px] items-center mt-[6px]">
                    <Checksvg/>
                    <p className="text-[14px] text-[#000000B2] flex flex-col gap-[10px] xl:max-w-[333px]">{t("account.84")}</p>
                </div>
                <div className="flex gap-[12px] items-center mt-[6px]">
                    <Checksvg/>
                    <p className="text-[14px] text-[#000000B2] flex flex-col gap-[10px] xl:max-w-[333px]">{t("account.85")}</p>
                </div>
                <div className="flex gap-[12px] items-center mt-[6px]">
                    <Checksvg/>
                    <p className="text-[14px] text-[#000000B2] flex flex-col gap-[10px] xl:max-w-[333px]">{t("account.86")}</p>
                </div>
                <div className="flex gap-[12px] items-center mt-[6px]">
                    <Checksvg/>
                    <p className="text-[14px] text-[#000000B2] flex flex-col gap-[10px] xl:max-w-[333px]">{t("account.87")}</p>
                </div>
                <div className="flex gap-[12px] items-center mt-[6px]">
                    <Checksvg/>
                    <p className="text-[14px] text-[#000000B2] flex flex-col gap-[10px] xl:max-w-[333px]">{t("account.88")}</p>
                </div>
                <div className="flex gap-[12px] items-center mt-[6px]">
                    <Checksvg/>
                    <p className="text-[14px] text-[#000000B2] flex flex-col gap-[10px] xl:max-w-[333px]">{t("account.89")}</p>
                </div>
            </div>
            <div className="bg-[#F1F7FE] rounded-[4px] p-[24px] flex flex-col">
                <p className="poppins text-[20px] text-[#1A0402] xl:text-[32px] font-[500] leading-[1.2] ">
                    {t("account.90")}
                </p>
                <p className="mt-[6px] poppins text-[16px] xl:text-[20px] font-[500] xl:max-w-[333px]">{t("account.91")}</p>
                <div className="mt-[16px] text-[14px] text-[#000000B2] flex flex-col gap-[10px] xl:max-w-[333px]">
                    {t("account.92")}
                </div>
                <p className="mt-[20px] xl:mt-[40px] poppins text-[16px] xl:text-[20px] font-[500] xl:max-w-[333px]">{t("account.74")}</p>
                <div className="flex gap-[12px] items-center mt-[12px]">
                    <Checksvg/>
                    <p className="text-[14px] text-[#000000B2] flex flex-col gap-[10px] xl:max-w-[333px]">{t("account.93")}</p>
                </div>
                <div className="flex gap-[12px] items-center mt-[6px]">
                    <Checksvg/>
                    <p className="text-[14px] text-[#000000B2] flex flex-col gap-[10px] xl:max-w-[333px]">{t("account.94")}</p>
                </div>
                <div className="flex gap-[12px] items-center mt-[6px]">
                    <Checksvg/>
                    <p className="text-[14px] text-[#000000B2] flex flex-col gap-[10px] xl:max-w-[333px]">{t("account.95")}</p>
                </div>
                <div className="flex gap-[12px] items-center mt-[6px]">
                    <Checksvg/>
                    <p className="text-[14px] text-[#000000B2] flex flex-col gap-[10px] xl:max-w-[333px]">{t("account.96")}</p>
                </div>
                <div className="flex gap-[12px] items-center mt-[6px]">
                    <Checksvg/>
                    <p className="text-[14px] text-[#000000B2] flex flex-col gap-[10px] xl:max-w-[333px]">{t("account.97")}</p>
                </div>
            </div>
        </div>
    </div>
  );
}

export default ChooseIndividual;